/**
 * Created by WebStorm.
 * User: samarasinghe
 * Date: 24/03/21
 * Time: 07:26 PM
 */
import * as actionTypes from '../actionTypes'

export const workspaceSaveHandler = (data) => {
  return {
    type: actionTypes.SAVE_WORKSPACE,
    value: data
  }
};

export const workspaceRemoveHandler = () => {
  return {
    type: actionTypes.REMOVE_WORKSPACE,
    value: null
  }
};

export const workspaceSaveReservationsHandler = (data) => {
  return {
    type: actionTypes.SAVE_RESERVATION_DATA,
    value: data
  }
};

export const workspaceRemoveReservationsHandler = () => {
  return {
    type: actionTypes.REMOVE_RESERVATION_DATA,
    value: null
  }
};

export const reservetionDateHandler = (data) => {
  return {
    type: actionTypes.STORE_RESERVATION_DATE,
    value: data
  }
};

